import React, { Children } from 'react';
import PropTypes from 'prop-types';

// ====

const Section = (props) => {
  const { children, className, align, marginBottom, column } = props;

  // ====

  return (
    <section
      className={`brand-section brand-link-blue ${className && className} ${
        marginBottom && 'mb-3 mb-md-4'
      }`}
    >
      <article className="container">
        <div className={`row justify-content-${align && align}`}>
          {column ? (
            <div className="col-12 brand-col">{children}</div>
          ) : (
            <>{children}</>
          )}
        </div>
      </article>
    </section>
  );
};

export default Section;

// ====

Section.propTypes = {
  align: PropTypes.string,
  className: PropTypes.string,
  marginBottom: PropTypes.bool,
  column: PropTypes.bool,
};

Section.defaultProps = {
  align: 'center',
  className: '',
  marginBottom: false,
  column: false,
};
